<template>

    <div class="flex h-3 sm:h-[16px]"
        >

        <Link v-for="(process,index) of processes"
            :href="process.href"
            :style="`width: ${ process.percent }%;`"
            class="h-[10px] sm:h-full relative activate_tooltip cursor-pointer border-white lg:rounded-lg mr-0.5 sm:mr-1.5"
            :class="{
                'bg-green': process.processed,
                'bg-blue': ! process.processed,
                'rounded-l-lg' : index === 0,
                'rounded-r-lg' : index === (processes.length - 1),
            }">

            <div class="tooltip absolute z-20 hidden rounded-lg"
                 style="
                    left: calc(-50% - 55px);
                    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
                    top: 36px;
                    min-width:250px;
                ">

                <div class="bg-white absolute z-10"
                    style="
                        transform: rotate(45deg);
                        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
                        width: 30px;
                        height: 30px;
                        top: -13px;
                        left: calc(50% - 15px);
                        border-radius: 5px;
                    "></div>

                <div class="relative w-full h-full z-20 p-3 bg-white rounded-lg"
                    style="
                    ">

                    {{ process.text }}

                </div>

            </div>

        </Link>

    </div>

</template>

<script>
import { defineComponent } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    name: "ProcessBar",

    components: {
        Link
    },

    props: {
        processes: {
            type: Array,
            default: () => {
                return [
                    {
                        percent: 50,
                        processed: true,
                        text: 'Example text - 1. Process',
                        href: '/test-link/'
                    },
                    {
                        percent: 50,
                        processed: false,
                        text: 'Example text - 2. Process',
                        href: '/test-link/'
                    }
                ]
            }
        }
    },



});
</script>

<style scoped>

.activate_tooltip:hover > .tooltip {
    display: block;
}

</style>
